import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import ScrollToTop from "./components/ScrollToTop";
import FloatingContact from "./components/FloatingContact";
import Home from "./pages/Home";
import NaturalHome from "./pages/NaturalHome";
import RevolutionaryHome from "./pages/RevolutionaryHome";
import AsianHornet from "./pages/AsianHornet";
import Contact from "./pages/Contact";
import MentionsLegales from "./pages/MentionsLegales";
import CGU from "./pages/CGU";
import PolitiqueConfidentialite from "./pages/PolitiqueConfidentialite";
import CGV from "./pages/CGV";
import Merci from "./pages/Merci";
import { Toaster } from "./components/ui/toaster";

// SEO Metadata Component for Natural Theme
const NaturalSEOHead = () => {
  React.useEffect(() => {
    // Update document title and meta tags
    document.title = "Frelon33™ | Experts frelons & nuisibles en Gironde";
    
    // Meta Description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Expert agréé en destruction de nids de frelons asiatiques en Gironde. Intervention sous 48h, méthodes respectueuses de l\'environnement. Devis gratuit : 06 76 58 30 38');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Expert agréé en destruction de nids de frelons asiatiques en Gironde. Intervention sous 48h, méthodes respectueuses de l\'environnement. Devis gratuit : 06 76 58 30 38';
      document.getElementsByTagName('head')[0].appendChild(meta);
    }

    // Meta Keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'frelon asiatique Gironde, destruction nid frelon, expert anti-nuisibles, intervention écologique, Bordeaux frelon, désinsectisation naturelle');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'keywords';
      meta.content = 'frelon asiatique Gironde, destruction nid frelon, expert anti-nuisibles, intervention écologique, Bordeaux frelon, désinsectisation naturelle';
      document.getElementsByTagName('head')[0].appendChild(meta);
    }

    // Open Graph Tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:title');
      meta.content = 'Frelon33 - Expert Anti-Nuisibles Écologique en Gironde';
      document.getElementsByTagName('head')[0].appendChild(meta);
    }

    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (!ogDescription) {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:description');
      meta.content = 'Intervention sous 48h • Méthodes respectueuses • Devis gratuit • Expert agréé en destruction de frelons asiatiques';
      document.getElementsByTagName('head')[0].appendChild(meta);
    }

    // Schema.org LocalBusiness JSON-LD
    const existingSchema = document.querySelector('script[type="application/ld+json"]');
    if (existingSchema) {
      existingSchema.remove();
    }
    
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "Frelon33 - Expert Anti-Nuisibles Écologique",
      "description": "Expert agréé en destruction de nids de frelons avec méthodes respectueuses de l'environnement en Gironde",
      "telephone": "+33676583038",
      "email": "frelon33000@gmail.com",
      "url": "https://www.frelon33.com",
      "address": {
        "@type": "PostalAddress",
        "addressRegion": "Gironde",
        "addressCountry": "FR"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "44.8378",
        "longitude": "-0.5792"
      },
      "serviceArea": {
        "@type": "GeoCircle",
        "geoMidpoint": {
          "@type": "GeoCoordinates",
          "latitude": "44.8378",
          "longitude": "-0.5792"
        },
        "geoRadius": "50000"
      },
      "openingHours": "Mo-Su 00:00-23:59",
      "priceRange": "€€",
      "image": "https://www.frelon33.com/OGIMAGEFRELON.jpg",
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Services de désinsectisation écologique",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Destruction écologique nid frelon asiatique",
              "description": "Intervention respectueuse de l'environnement pour élimination de nids de frelons asiatiques"
            }
          },
          {
            "@type": "Offer", 
            "itemOffered": {
              "@type": "Service",
              "name": "Traitement naturel nids de guêpes",
              "description": "Élimination sécurisée avec méthodes respectueuses de la biodiversité"
            }
          }
        ]
      },
      "areaServed": [
        "Cadaujac",
        "Bordeaux",
        "Mérignac",
        "Pessac",
        "Talence",
        "Gironde"
      ],
      "additionalProperty": [
        {
          "@type": "PropertyValue",
          "name": "Intervention Time",
          "value": "< 48 heures"
        },
        {
          "@type": "PropertyValue",
          "name": "Approach",
          "value": "Écologique et respectueuse"
        }
      ]
    });
    document.getElementsByTagName('head')[0].appendChild(script);
  }, []);

  return null;
};

function App() {
  return (
    <div className="App">
      <NaturalSEOHead />
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            {/* Natural homepage as default */}
            <Route path="/" element={<NaturalHome />} />
            {/* Keep other versions for comparison */}
            <Route path="/classic" element={<Home />} />
            <Route path="/revolutionary" element={<RevolutionaryHome />} />
            <Route path="/frelon-asiatique" element={<AsianHornet />} />
            <Route path="/contact" element={<Contact />} />
            {/* SEO-friendly URLs */}
            <Route path="/expert-frelon-gironde" element={<NaturalHome />} />
            <Route path="/intervention-ecologique-frelon" element={<NaturalHome />} />
            <Route path="/destruction-nid-frelon-bordeaux" element={<NaturalHome />} />
            <Route path="/urgence-frelon-asiatique" element={<Contact />} />
            {/* Pages légales */}
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/cgu" element={<CGU />} />  
            <Route path="/conditions-generales-utilisation" element={<CGU />} />
            <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
            <Route path="/cgv" element={<CGV />} />
            <Route path="/conditions-generales-vente" element={<CGV />} />
            {/* Page de confirmation (noindex) */}
            <Route path="/merci" element={<Merci />} />
          </Routes>
        </main>
        <Footer />
        <CookieBanner />
        <FloatingContact />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;